// @flow
import {call} from 'redux-saga/effects'
import React from 'react'
import PropTypes from 'prop-types'
import {BrowserRouter as Router} from 'react-router-dom'
import RootRoutes from '$src/root/components/RootRoutes'
import I18NProvider from '$src/i18n/components/I18NProvider'
import css from './Root.css'

function* preventFromThrowing(fn, ...args) {
  try {
    return yield call(fn, ...args)
  } catch (e) {
    return Promise.reject(e)
  }
}

class Root extends React.Component<*, *> {
  static childContextTypes = {
    runSaga: PropTypes.any,
  }

  getChildContext() {
    return {
      runSaga: (fn: Generator<*, *>, ...args: Array<mixed>): ?Promise<*> =>
        this.props.runSaga(preventFromThrowing, fn, ...args).done,
    }
  }

  render() {
    return (
      <div className={css.component}>
        <I18NProvider>
          <Router>{RootRoutes}</Router>
        </I18NProvider>
      </div>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/root/components/Root.js